// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-title-main {
  padding-top: var(--spacing-regular);
}
.vert-button:not([disabled]).ant-btn-default.button-historic-redirect {
  color: var(--color-highlight) !important;
  border-color: var(--color-highlight) !important;
}
.datepicker-delivery {
  box-shadow: none !important;
}
.datepicker-delivery-popup .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel {
  width: var(--footer-size-logo-maxwidth);
}
.datepicker-delivery-popup .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel .ant-picker-body {
  padding: var(--spacing-small);
  align-self: center;
}
.datepicker-delivery-popup .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel .ant-picker-header .ant-picker-header-view {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-extra-small);
}
.table-focal-point .ant-table-expanded-row {
  background-color: #FFF;
}
.table-focal-point .ant-table-expanded-row .ant-table-cell {
  background-color: #FFF;
}
.table-focal-point .ant-table-expanded-row:hover .ant-table-cell {
  background-color: #FFF;
}
.table-focal-point .ant-table-content {
  overflow-y: auto;
}
.table-focal-point table {
  min-width: 1400px;
}
.loading-space {
  width: 100%;
  margin-top: var(--spacing-extra-big);
}
.text-title {
  font-size: var(--font-giant);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
@media screen and (max-width: 437px) {
  .text-title {
    font-size: var(--font-big);
    margin-bottom: var(--spacing-small);
  }
}
.text-not-found {
  color: var(--color-neutral-dark-lighter);
  font-size: var(--font-giant);
}
.text-status-approved {
  color: var(--success-color);
  filter: brightness(0.6);
}
.text-status-pending {
  color: var(--warning-color);
  filter: brightness(0.6);
}
.action-button {
  color: var(--color-highlight);
}
.action-button-disabled {
  color: var(--color-neutral-light);
}
.container-participant-info {
  display: 'flex';
  flex-direction: 'column';
}
.arrow-back-div {
  display: flex;
  align-items: center;
  justify-content: end;
  color: var(--color-highlight) !important;
  gap: var(--spacing-extra-small);
}
.container-chip-status {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.arrow-back {
  font-size: var(--spacing-regular);
  color: var(--color-highlight) !important;
}
.text-align-content {
  text-align: center !important;
}
.margin-top-spacing {
  margin-top: var(--spacing-regular);
}
.margin-bottom-spacing {
  margin-bottom: var(--spacing-small);
}
.user-information-title {
  font-weight: bold;
}
.solicitation-status {
  font-weight: 500;
  font-size: var(--spacing-extra-small);
}
.solicitation-status-text {
  padding: var(--spacing-extra-small);
  background-color: var(--success-color) !important;
  border-radius: var(--spacing-regular);
}
.table-action-focal-point {
  color: var(--color-highlight);
}
.container-show-details-column {
  min-width: 120px;
}
.color-disabled {
  color: var(--color-neutral-dark-lighter);
}
.text-align-content {
  text-align: center !important;
}
.margin-top-spacing {
  margin-top: var(--spacing-regular);
}
.margin-top-extra-small {
  margin-top: var(--spacing-extra-small);
}
.margin-bottom-spacing {
  margin-bottom: var(--spacing-small);
}
.button-100-width {
  width: 100%;
}
.status-approved-background {
  padding: var(--spacing-extra-small);
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);
  background-color: hsl(from var(--success-color) h s l / 0.3);
  border-radius: var(--border-radius-base);
}
.chip-status-distribution {
  padding: var(--spacing-extra-small);
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);
  border-radius: var(--border-radius-base);
  text-align: center;
  min-width: 210px;
}
.chip-status-distribution-approved {
  background-color: hsl(from var(--success-color) h s l / 0.3);
}
.chip-status-distribution-pending {
  background-color: hsl(from var(--warning-color) h s l / 0.3);
}
.text-status-distribution-approved {
  color: var(--success-color);
  filter: brightness(0.6);
}
.text-status-distribution-pending {
  color: var(--warning-color);
  filter: brightness(0.6);
}
.status-pending-background {
  padding: var(--spacing-extra-small);
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);
  background-color: hsl(from var(--warning-color) h s l / 0.3);
  border-radius: var(--border-radius-base);
}
.text-status-distribution-error {
  color: var(--error-color);
  filter: brightness(0.6);
}
.status-error-background {
  padding: var(--spacing-extra-small);
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);
  background-color: hsl(from var(--error-color) h s l / 0.3);
  border-radius: var(--border-radius-base);
}
.margin-top-spacing-giant {
  margin-top: var(--form-item-height);
}
.ant-select .ant-select-clear {
  width: var(--spacing-extra-big);
}
@media screen and (max-width: 574px) {
  .justify-max-width {
    justify-content: start;
  }
}
@media screen and (max-width: 574px) {
  .font-size-max-width {
    font-size: var(--font-small);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/FocalPoint/ListManagePointsStyles.less"],"names":[],"mappings":"AACA;EACI,mCAAA;AAAJ;AAGA;EACI,wCAAA;EACA,+CAAA;AADJ;AAIA;EACI,2BAAA;AAFJ;AAKA;EAKoB,uCAAA;AAPpB;AAEA;EAQwB,6BAAA;EACA,kBAAA;AAPxB;AAFA;EAc4B,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AAT5B;AAkBA;EAGQ,sBAAA;AAlBR;AAeA;EAMY,sBAAA;AAlBZ;AAYA;EAYY,sBAAA;AArBZ;AASA;EAiBQ,gBAAA;AAvBR;AAMA;EAqBQ,iBAAA;AAxBR;AA4BA;EACI,WAAA;EACA,oCAAA;AA1BJ;AA6BA;EACI,4BAAA;EACA,gBAAA;EACA,gCAAA;AA3BJ;AA6BI;EAAA;IACI,0BAAA;IACA,mCAAA;EA1BN;AACF;AA6BA;EACI,wCAAA;EACA,4BAAA;AA3BJ;AA8BA;EACI,2BAAA;EACA,uBAAA;AA5BJ;AA+BA;EACI,2BAAA;EACA,uBAAA;AA7BJ;AAgCA;EACI,6BAAA;AA9BJ;AAiCA;EACI,iCAAA;AA/BJ;AAkCA;EACI,eAAA;EACA,wBAAA;AAhCJ;AAmCA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,wCAAA;EACA,+BAAA;AAjCJ;AAoCA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAlCJ;AAqCA;EACI,iCAAA;EACA,wCAAA;AAnCJ;AAsCA;EACI,6BAAA;AApCJ;AAuCA;EACI,kCAAA;AArCJ;AAwCA;EACI,mCAAA;AAtCJ;AAyCA;EACI,iBAAA;AAvCJ;AA0CA;EACI,gBAAA;EACA,qCAAA;AAxCJ;AA2CA;EACI,mCAAA;EACA,iDAAA;EACA,qCAAA;AAzCJ;AA4CA;EACI,6BAAA;AA1CJ;AA6CA;EACI,gBAAA;AA3CJ;AA8CA;EACI,wCAAA;AA5CJ;AA+CA;EACI,6BAAA;AA7CJ;AAgDA;EACI,kCAAA;AA9CJ;AAiDA;EACI,sCAAA;AA/CJ;AAkDA;EACI,mCAAA;AAhDJ;AAmDA;EACI,WAAA;AAjDJ;AAoDA;EACI,mCAAA;EACA,kCAAA;EACA,mCAAA;EACA,4DAAA;EACA,wCAAA;AAlDJ;AAqDA;EACI,mCAAA;EACA,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAnDJ;AAsDA;EACI,4DAAA;AApDJ;AAuDA;EACI,4DAAA;AArDJ;AAwDA;EACI,2BAAA;EACA,uBAAA;AAtDJ;AAyDA;EACI,2BAAA;EACA,uBAAA;AAvDJ;AA0DA;EACI,mCAAA;EACA,kCAAA;EACA,mCAAA;EACA,4DAAA;EACA,wCAAA;AAxDJ;AA2DA;EACI,yBAAA;EACA,uBAAA;AAzDJ;AA4DA;EACI,mCAAA;EACA,kCAAA;EACA,mCAAA;EACA,0DAAA;EACA,wCAAA;AA1DJ;AA6DA;EACI,mCAAA;AA3DJ;AA8DA;EACI,+BAAA;AA5DJ;AAgEI;EAAA;IACI,sBAAA;EA7DN;AACF;AAiEI;EAAA;IACI,4BAAA;EA9DN;AACF","sourcesContent":["//DESKTOP\n.container-title-main {\n    padding-top: var(--spacing-regular);\n}\n\n.vert-button:not([disabled]).ant-btn-default.button-historic-redirect {\n    color: var(--color-highlight) !important;\n    border-color: var(--color-highlight) !important;\n}\n\n.datepicker-delivery {\n    box-shadow: none !important;\n}\n\n.datepicker-delivery-popup {\n    .ant-picker-panel-container {\n        .ant-picker-panel-layout {\n            .ant-picker-panel {\n                .ant-picker-date-panel {\n                    width: var(--footer-size-logo-maxwidth);\n\n                    .ant-picker-body {\n                        padding: var(--spacing-small);\n                        align-self: center;\n                    }\n\n                    .ant-picker-header {\n                        .ant-picker-header-view {\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            gap: var(--spacing-extra-small);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.table-focal-point {\n\n    .ant-table-expanded-row {\n        background-color: #FFF;\n\n        .ant-table-cell {\n            background-color: #FFF;\n        }\n    }\n\n    .ant-table-expanded-row:hover {\n        .ant-table-cell {\n            background-color: #FFF;\n        }\n    }\n\n    .ant-table-content {\n        overflow-y: auto;\n    }\n\n    table {\n        min-width: 1400px;\n    }\n}\n\n.loading-space {\n    width: 100%;\n    margin-top: var(--spacing-extra-big);\n}\n\n.text-title {\n    font-size: var(--font-giant);\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n\n    @media screen and (max-width: 437px) {\n        font-size: var(--font-big);\n        margin-bottom: var(--spacing-small);\n    }\n}\n\n.text-not-found {\n    color: var(--color-neutral-dark-lighter);\n    font-size: var(--font-giant);\n}\n\n.text-status-approved {\n    color: var(--success-color);\n    filter: brightness(0.6);\n}\n\n.text-status-pending {\n    color: var(--warning-color);\n    filter: brightness(0.6);\n}\n\n.action-button {\n    color: var(--color-highlight);\n}\n\n.action-button-disabled {\n    color: var(--color-neutral-light);\n}\n\n.container-participant-info {\n    display: 'flex';\n    flex-direction: 'column'\n}\n\n.arrow-back-div {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    color: var(--color-highlight) !important;\n    gap: var(--spacing-extra-small);\n}\n\n.container-chip-status {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.arrow-back {\n    font-size: var(--spacing-regular);\n    color: var(--color-highlight) !important;\n}\n\n.text-align-content {\n    text-align: center !important;\n}\n\n.margin-top-spacing {\n    margin-top: var(--spacing-regular);\n}\n\n.margin-bottom-spacing {\n    margin-bottom: var(--spacing-small);\n}\n\n.user-information-title {\n    font-weight: bold;\n}\n\n.solicitation-status {\n    font-weight: 500;\n    font-size: var(--spacing-extra-small);\n}\n\n.solicitation-status-text {\n    padding: var(--spacing-extra-small);\n    background-color: var(--success-color) !important;\n    border-radius: var(--spacing-regular);\n}\n\n.table-action-focal-point {\n    color: var(--color-highlight);\n}\n\n.container-show-details-column {\n    min-width: 120px;\n}\n\n.color-disabled {\n    color: var(--color-neutral-dark-lighter);\n}\n\n.text-align-content {\n    text-align: center !important;\n}\n\n.margin-top-spacing {\n    margin-top: var(--spacing-regular);\n}\n\n.margin-top-extra-small {\n    margin-top: var(--spacing-extra-small);\n}\n\n.margin-bottom-spacing {\n    margin-bottom: var(--spacing-small);\n}\n\n.button-100-width {\n    width: 100%;\n}\n\n.status-approved-background {\n    padding: var(--spacing-extra-small);\n    padding-left: var(--spacing-small);\n    padding-right: var(--spacing-small);\n    background-color: hsl(from var(--success-color) h s l / 0.3);\n    border-radius: var(--border-radius-base);\n}\n\n.chip-status-distribution {\n    padding: var(--spacing-extra-small);\n    padding-left: var(--spacing-small);\n    padding-right: var(--spacing-small);\n    border-radius: var(--border-radius-base);\n    text-align: center;\n    min-width: 210px;\n}\n\n.chip-status-distribution-approved {\n    background-color: hsl(from var(--success-color) h s l / 0.3);\n}\n\n.chip-status-distribution-pending {\n    background-color: hsl(from var(--warning-color) h s l / 0.3);\n}\n\n.text-status-distribution-approved {\n    color: var(--success-color);\n    filter: brightness(0.6);\n}\n\n.text-status-distribution-pending {\n    color: var(--warning-color);\n    filter: brightness(0.6);\n}\n\n.status-pending-background {\n    padding: var(--spacing-extra-small);\n    padding-left: var(--spacing-small);\n    padding-right: var(--spacing-small);\n    background-color: hsl(from var(--warning-color) h s l / 0.3);\n    border-radius: var(--border-radius-base);\n}\n\n.text-status-distribution-error {\n    color: var(--error-color);\n    filter: brightness(0.6);\n}\n\n.status-error-background {\n    padding: var(--spacing-extra-small);\n    padding-left: var(--spacing-small);\n    padding-right: var(--spacing-small);\n    background-color: hsl(from var(--error-color) h s l / 0.3);\n    border-radius: var(--border-radius-base);\n}\n\n.margin-top-spacing-giant {\n    margin-top: var(--form-item-height);\n}\n\n.ant-select .ant-select-clear {\n    width: var(--spacing-extra-big);\n}\n\n.justify-max-width {\n    @media screen and (max-width: 574px) {\n        justify-content: start;\n    }\n}\n\n.font-size-max-width {\n    @media screen and (max-width: 574px) {\n        font-size: var(--font-small);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
